import React, {useEffect, useState} from 'react'
import { Input} from "reactstrap";
import {eventByDate} from 'network/ApiAxiosTickets'
import { eventBySingleDayReport } from 'network/ApiAxiosReportsGetickets';

function EventDropdown(props) {
    const [event, setEvent] = useState()

    useEffect(() => {
      console.log(props.date)
        getEvent()
      }, [props.date]);
    
      const getEvent = async()=>{
        const  response = await eventBySingleDayReport(props.date)
        setEvent(response.data.records)
      }


  return (
    <Input style={{width:props.width}} type="select" onChange={(e)=>props.handler(e.target.value)} >
        {event ? <option key="choose" value='1' label='Choose a event' />:
        <option key='Loading...' value='1' label='Loading...' />}
        {event && event.map((event)=>{
        return <option key={event._id} value={event._id} label={event.venue + " " + event.name} />
        })}
        
    </Input>
  )
}

export default EventDropdown